"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateDeviceControlTransaction = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const uuid_1 = require("uuid");
const util_1 = require("../../util");
const DeviceControlTransaction_1 = require("./DeviceControlTransaction");
const debugOverride = process.env.DEBUG_OVERRIDE === 'true';
const debug = (!process.env.AWS_SESSION_TOKEN && false) || debugOverride;
const generateDeviceControlTransaction = ({ broadcastData, device, initialPayloadStr, desiredPayload, requestInitiator, messageType, }) => {
    const MessageType = device.deviceType ?? messageType;
    const { appID, deviceId, eui, networkKey } = device;
    const params = {
        ApplicationId: appID,
        device,
        RequestId: (0, uuid_1.v4)(),
        MessageType,
        initialPayloadStr,
        desiredPayload,
        downlinkAction: iotv_v3_types_1.DownlinkAction.PUSH,
        networkKey: networkKey,
    };
    const { broadcastScheduleSk, broadcastTimestamp } = broadcastData ?? {};
    const now = Date.now();
    const timestamp = broadcastTimestamp ?? now;
    const ttl = (0, util_1.getTTLSeconds)(1); // 1 day from now
    // PUT and INSERT will fail if an empty string is used in an index
    const dKeys = networkKey === iotv_v3_types_1.Networks.AWS_LPWAN ? eui // For AWS Devices dsk is used to index AWS_MessageId so dpk becomes eui and is not updated as correlationId in device-state
        : deviceId && deviceId !== '' ? deviceId : undefined;
    const props = {
        devicePk: device.sk,
        initialPayloadStr,
        initialRequest: params,
        requestInitiator,
        status: iotv_v3_types_1.DeviceTransactionStatus.USER_REQUESTED,
        timestamp,
        ttl,
        dpk: dKeys,
        dsk: dKeys,
        broadcastScheduleSk,
    };
    /** 230916 changed transaction id to be begins_with sortable on timestamp in ms, from uuid v4, appended with device id to prevent per millisecond duplicates (!!) */
    const transactionId = `${now}_${device.id}`;
    const sk = `DeviceControlTransaction:${transactionId}`;
    const id = transactionId;
    const deviceControlTransaction = new DeviceControlTransaction_1.DeviceControlTransaction(props);
    const transactionName = `${requestInitiator.name ?? requestInitiator.id} DCT for ${device.eui ?? device.id} `;
    deviceControlTransaction.name = transactionName;
    deviceControlTransaction.sk = sk;
    deviceControlTransaction.id = id;
    deviceControlTransaction.transactionStages.push({
        status: iotv_v3_types_1.DeviceTransactionStatus.USER_REQUESTED,
        timestampsMs: now,
        correlationId: undefined,
        responseObject: undefined,
    });
    debug && console.log('JSON for test', JSON.stringify(deviceControlTransaction, null, 1));
    return deviceControlTransaction;
};
exports.generateDeviceControlTransaction = generateDeviceControlTransaction;
